<template>
  <div class="sec-features-list" v-if="!!listData && Object.keys(listData).length > 0">
    <swiper ref="swiper" :options="swiperOptions">
      <swiper-slide
        class="slide-item"
        v-for="(item, idx) in listItems"
        :key="idx"
      >
        <a
          :href="item.url"
          @click.prevent="onItemClick($event, item)">
          <img :src="item.thumb" :alt="item.title" @error="onImageLoadError">
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ArrowIcon from '@/utvStore/components/common/icon/ArrowIcon'

export default {
  name: 'SecFeaturesList',
  components: {
    swiper,
    swiperSlide,
    ArrowIcon,
  },
  props: {
    listData: {
      type: Object,
    }
  },
  computed: {
    listItems() {
      return !!this.listData.items ? this.listData.items : []
    },
    swiperOptions() {
      return {
        // autoplay: {delay: 3000},
        // autoHeight: true,
        // spaceBetween: -20,
        slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: false,
        // loop: true,
        // allowTouchMove: this.infoBanner.length > 1,
      }
    }
  },
  methods: {
    onItemClick(e, params) {
      location.href = params.url
    },
    onImageLoadError(e) {
      e.target.classList.add('load-error')
    }
  }
}</script>

<style scoped lang="scss">
.sec-features-list {
  /deep/ .swiper-container {
    padding: 0 20px;
    filter: drop-shadow(4px 4px 4px rgba(0,0,0, 0.1));
  }
  //padding: 0 20px;
  .slide-item {
    width: 42.9%;
    padding: 0 4px;
    a {
      width: 100%;
      height: 0;
      position: relative;
      display: block;
      background: #d9d9d9;
      border-radius: 10px;
      overflow: hidden;
      padding: 62.11% 0 0;
      &::after {
        content: 'no images';
        color: #b9b9b9;;
        font-size: 12px;
        position: absolute;
        width: fit-content;
        height: fit-content;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 1;
      }
      img {
        width: 100%;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        &.load-error {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/section/SecFeaturesList.vue